/* global require, InfiniteScroll */
;$(function () {
  'use strict'

  var $container = $('[data-infinite-scroll]')
  var startOnButton = $container.data('infiniteScrollStartOnButton') || false
  var nextPageSelector = '[data-infinite-scroll-next-page]'
  var prevPageNavSelector = '[data-infinite-scroll-prev-nav]'
  var prevPageSelector = '[data-infinite-scroll-prev-page]'
  var elementSelector = '[data-infinite-scroll-element]'
  var navSelector = '[data-infinite-scroll-nav]'
  var statusSelector = '[data-infinite-scroll-status]'
  var $nextPage = $(nextPageSelector)
  var nextPageUrl = ''
  if ($nextPage) {
    nextPageUrl = $nextPage.attr('href')
  }
  var $prevPage = $(prevPageSelector)
  var prevPageUrl = ''
  if ($prevPage) {
    prevPageUrl = $prevPage.attr('href')
  }

  $container.infiniteScroll({
    append: elementSelector,
    path: function () {
      if (nextPageUrl !== '') {
        return nextPageUrl
      }
    },
    checkLastPage: true,
    hideNav: startOnButton ? false : navSelector,
    history: false,
    status: statusSelector,
    loadOnScroll: !startOnButton
  })

  if (startOnButton) {
    $(statusSelector).hide()
    $nextPage.on('click', function (e) {
      e.preventDefault()
      $container.infiniteScroll('loadNextPage')
      $container.infiniteScroll('option', {
        loadOnScroll: true,
        hideNav: navSelector
      })
      $(navSelector).hide()
      $(statusSelector).show()
    })
  }

  function processNextPage (response) {
    var $nextPage = $(response).find(nextPageSelector)
    if ($nextPage && $nextPage.length) {
      nextPageUrl = $nextPage.attr('href')
    }
    else {
      nextPageUrl = ''
    }
  }

  function processPrevPage ($response) {
    var $prevPage = $response.find(prevPageSelector)
    if ($prevPage && $prevPage.length > 0) {
      prevPageUrl = $prevPage.attr('href')
    }
    else {
      prevPageUrl = ''
    }

    if (!prevPageUrl) {
      $(prevPageNavSelector).hide()
    }
  }

  $container.on('load.infiniteScroll', function (event, response, path) {
    processNextPage(response)
    $container.data('infiniteScroll').checkLastPage(response, path)
    window.initPhotoOverlay()
  })

  $container.on('append.infiniteScroll', function (event, response, path, items) {
    $(document).trigger('infiniteScroll::loaded')
  })

  $(document).on('click', prevPageSelector, function (event) {
    event.preventDefault()

    $.ajax({
      url: prevPageUrl,
      type: 'GET'
    }).done(function (response) {
      try {
        var $html = $('<div>' + response + '</div>')
        processPrevPage($html)
        var $elements = $html.find(elementSelector)
        var fragment = document.createDocumentFragment()
        for (var i = 0; $elements && i < $elements.length; i++) {
          fragment.appendChild($elements[i])
        }

        $container.prepend(fragment)
        window.initPhotoOverlay()
      }
      catch (e) {
        console.log(e)
      }
    })
  })
})
